module.exports = __webpack_public_path__ + "img/1F1EC-1F1E7.2ca92b6b.svg";